module.exports = __webpack_public_path__ + "media/images/clock-2a4311c1da11b157c6ac84fe29c22805.png";